import { ErrorRecord } from 'src/hooks/useForm';

export enum WEBHOOK_EVENT_IDS {
  TWP_CREATION = 1,
  TWP_UPDATE,
  TWP_DECISION,
  TWP_CORRESPONDENCE,
  DAILY_UPDATE,
}

export enum ACCOMMODATION_TYPE_IDS {
  AUSTIN = 1,
  DALI,
  BALI,
}

export interface SiteWebhook {
  id: number;
  siteId: number;
  webhookEventId: WEBHOOK_EVENT_IDS;
  accommodationTypeId: ACCOMMODATION_TYPE_IDS;
  webhookUrl: string;

  // returned from backend but unused on frontend
  editedBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface SiteWebhookCreateOrUpdate extends Omit<SiteWebhook, 'id' | 'editedBy' | 'createdAt' | 'updatedAt'> {
  id?: number;
}

export interface SiteWebhookFormEntry extends Omit<Partial<SiteWebhook>, 'editedBy' | 'createdAt' | 'updatedAt'> {
  newOrUpdated?: boolean;
}

export interface IndexedSiteWebhookFormEntry {
  index: number;
  webhook: SiteWebhookFormEntry;
}

export interface WebhookFormErrors {
  [key: number]: ErrorRecord<SiteWebhookFormEntry>;
}
